const Form092SC = {
    stepName: {
        importantNotes: "重要提示",
        applicationInformation: "申请资料",
        confirmation: "确认",
    },

    mainTitle: {
        title: "重要提示",
        picTitle: "个人资料收集声明",
    },

    importantNotesContent: {
        p1_1: "请在填写此表格前先阅读载于以下的个人资料收集声明。申请人必须提供有关资料。如提供的资料不足，则可能导致款项延迟发放。",
        p1_b1: "如提款申请书",
        p1_u: "填报正确",
        p1_b2: "，则公积金组可于接获申请书后或由申请人受雇的最后日期起计(以较迟者为准)的二十三个工作天(如在八月至九月期间则为二十八个工作天)内发放公积金款项。",

        p2_1: "为了保障你的权益，请在填写此表格前先阅读《补助学校公积金规则》(第279C 章) 第九及十三条，特别是第十三(2A)",
        p2_i: "(b)",
        p2_2: "条。有关规则，可浏览律政司网页",
        p2_link: "http://www.elegislation.gov.hk",
        p2_3: "。.",

        p3: "倘提款申请书之日期较第九段所述者为早，则提款申请书之日期将会被视作户口终结之日期。",
        p4: "申请人如欲作任何更改，则须由其删去所需要更改的地方，并在该处加以签署。其后申请书填报的资料如有改变，申请人须立即书面通知公积金组。",

        p5_1: "申请人须将本申请书交回其所属学校。申请书经校长/校监证明后，必须由所属学校交回",
        p5_bu: "香港湾仔皇后大道东213号胡忠大厦15楼1517室",
        p5_2: "教育局公积金组。",

        p6_1: "公积金组会在接获申请书后十四个工作天内向申请人及其所属学校发出认收信。如申请人在十四个工作天内没有收到该信，应致电",
        p6_b1: "2892 6222",
        p6_b2: "2892 5780",
        p6_2: "向公积金组查询。",

        p7: "如供款人要求以外币汇款方式退款，可从以下十种货币选择其中一种：澳大利亚元、加拿大元、欧罗、日元、纽西兰元、新加坡元、瑞士法郎、泰铢、英镑和美元。",
    },

    iamStatement:"为了处理本申请，本人明白 (i) 申请人需要拥有“iAM Smart+”账户，以及 (ii) 申请人需要向学校的审批部门确认他们拥有“iAM Smart+”账户。",
    
    note: {
        note1: {
            title: `1.	你在本表格提供的个人资料，会供教育局用于以下一项或多项用途：`,
            subtitle: "收集个人资料的目的",
            content1: "(a)	处理、核实及查证就补助学校公积金提款的申请；",
            content2:
                "(b)	就上文(a)项所述申请的处理、核实及查证，将个人资料与政府相关政策局／部门资料库进行核对；",
            content3:
                "(c)	将个人资料与教育局资料库进行核对，以核实／更新教育局的记录；",
            content4:
                "(d)	培训及发展，包括发出计划／活动邀请、处理发还课程费用申请、评审提名、奖项和奖学金，以及监察达标进度；",
            content5:
                "(e)	处理及审核拨款／补助／津贴申请、发放拨款／补助／津贴，以及审计；",
            content6: "(f)	编制统计资料、研究及政府刊物；以及",
            content7:
                "(g)	执行规则及规例[包括《教育条例》(香港法例第279章)及其附属法例(例如《教育规例》、《补助学校公积金规则》、《津贴学校公积金规则》)和《资助则例》)]。",
        },
        note2: {
            title: `2.	你必须按本表格的要求及于本局处理本表格的过程中提供个人资料。假如你没有提供该等个人资料，本局可能无法办理或继续处理申请。 `,
        },
        note3: {
            title: `3.	你提供的个人资料会供教育局人员取阅。除此之外，本局亦可能会向下列各方或在下述情况转移或披露该等个人资料：`,
            subtitle: "可获转移资料者",
            content1:
                "(a)	政府其他政策局及部门，包括库务署，以用于上文第1段所述的用途；",
            content2: "(b)	与本表格相关的学校，以用于上文第1段所述的用途；",
            content3:
                "(c)	受聘于教育局以提供服务或意见的人员、代理人、服务供应商或机构，以用于上文第1段所述的用途；",
            content4: "(d)	你曾就披露个人资料给予订明同意；以及",
            content5:
                "(e)	根据适用于香港的法例或法庭命令授权或规定披露个人资料。",
        },
        note4: {
            title: `4.	你有权要求查阅及更正教育局所持有关于你的个人资料。如需查阅或更正个人资料，请以书面向以下人士提出：`,
            subtitle: "查阅个人资料",
        },
    },

    address: {
        address1: "    一级会计主任(公积金)2 ",
        address2: "    教育局公积金组",
        address3: "    香港湾仔皇后大道东213号胡忠大厦15 楼1517室",
        address4: "",
    },

    applicationInformationContent: {
        label: {
            formTitle: "个人资料",

            nameOfContributorEN: "供款人英文姓名 (请依照香港身份证)",
            nameOfContributorCH: "供款人中文姓名 (请依照香港身份证)",

            hkid: "香港身份证号码",
            dateOfBirth: "出生日期",
            addressEN: "英文住址",
            telNo: "电话",
            staffNo: "员工档号",

            lastSchoolEmployment: "最后任职之学校",
            primaryOrSecondaryOption: {
                primary: "小学",
                secondary: "中学",
            },
            schoolOption: {
                schoolA: "学校甲",
                schoolB: "学校乙",
                schoolC: "学校丙",
            },
            schoolName: "学校名称",

            schoolCode: "学校编号",
            lastEmploymentDate: "最后任职之日期",
            lastAccountKeptOpen:
                "已批准公积金户口保留之最后日期(适用者方可填写)",

            terminationReason: "停止任职原因",
            terminationReasonOption: {
                resignation: "辞职",
                retirement: "退休",
                dismissal: "撤职",
                death: "死亡",
                illHealth: "健康不佳 (规则第十三(1)(b)条适用)",
                others: "其他",
            },
            pleaseState: "请说明",

            paymentOfProvident: "付款方法",
            paymentOfProvidentOption: {
                byBank: "存入下开本人名下之银行港币来往或储蓄户口，而一切入帐由银行认收即可，不必由本人亲自领取。本人会负责因填报银行户口帐号不正确而需缴付的任何银行服务收费，并同意由本人之公积金利益扣除。",

                byCheque:
                    "将书明本人收款之银行汇票寄送/电汇下开香港特别行政区以外的地址/银行户口，所需手续费由本人之公积金利益扣除。 (请参照申请需知注释(七)及列明其中一种指定货币)",
            },

            // label of by bank
            bankCode: "银行代码",
            branchCode: "分行代码",
            accountNo: "帐号",
            bankName: "银行名称",

            // label of by cheque
            overseaAddressOrBankAccount: "地址/银行户口",
            currency: "货币",

            // for signing
            signingDeclare:
                "本人已阅毕载于附录 2013 年教育(修订)条例并明白修订条例旨在保障破产的公积金成员在根据该条例维持的公积金中的收益。",
            signingDeclare1: "本人已阅毕载于",
            appendix: "附录",
            signingDeclare2:
                " 2013 年教育(修订)条例并明白修订条例旨在保障破产的公积金成员在根据该条例维持的公积金中的收益。",
            signing1Declare: "本人已阅毕甲部第十二段和丁部的注释",
            signing2Declare:
                "兹证明上述第一，二，三，六，七，八及十段所载之资料属实",

            sign1Name: "申请人姓名",
            sign1Date: "日期",

            sign2Name: "姓名",
            sign2Post: "职位",
            sign2PostOption: {
                schoolHead: "校长",
                supervisor: "校监",
            },
            sign2Date: "日期",

            //school chop
            schoolChop: "学校印章",
        },
        errorMsg: {
            // test field unit
            nameOfApplicationEn: "申请人姓名（英文）",
            nameOfApplicationCh: "申请人姓名（中文）",
            nameEN: "英文姓名",
            nameCH: "中文姓名",
            name: "申请人姓名",

            addressEN: "英文住址",
            accountNo: "帐号",

            // specific test message
            telNo: "电话号码必须为8位数字",
            staffNo: "员工档号必须为8位数字",
            schoolCode: "学校编号必须为4位数字",
            bankCode: "银行代码必须为3位数字",
            threeMonth: "此日期必须在今日后的三个月内",
            afterLastEmploymentDate: "此日期必须在最后任职日期之后",
            atMostOneOption: "此选项只能选择一项",
        },
    },
};
export default Form092SC;
